<template>
  <b-form-group
    label="Adı Soyadı"
    label-for="donor_name"
  >
    <b-form-input
      id="donor_name"
      v-model="dataItem.donor_name"
      placeholder="Adı Soyadı"
    />
  </b-form-group>
</template>

<script>
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'

export default {
  name: 'DonorName',
  components: {
    BFormGroup,
    BFormInput,
  },
  computed: {
    dataItem() {
      return this.$store.getters['accountActivities/dataItem']
    },
  },
}
</script>
